import React from "react";
import { Column, Columns, Stack } from "@origin-digital/ods-core";
import HelperText from "./HelperText";

interface ISingleFieldFormLayout {
  children: React.ReactNode;
  text?: string | React.ReactNode;
  multipleFields?: boolean;
}

const FormFieldLayout: React.FC<ISingleFieldFormLayout> = ({
  children,
  text,
  multipleFields = false,
}) => (
  <Columns
    collapseBelow="md"
    space={{ xs: "none", md: "xlarge" }}
    alignY="stretch"
  >
    <Column width="2/3">
      {multipleFields ? (
        <Stack
          space={{
            xs: "large",
            md: "xlarge",
          }}
        >
          {children}
        </Stack>
      ) : (
        children
      )}
    </Column>
    {text ? (
      <Column>
        <HelperText text={text} />
      </Column>
    ) : null}
  </Columns>
);

export default FormFieldLayout;
